import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["modules", "className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { contentId } from '@uswitch/ev-utils/contentful';
import { EVEntry } from '@uswitch/ev-core/react';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { createElement as _createElement } from "theme-ui";
export var moduleEntity = function moduleEntity(mod) {
  var extraData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var props = _objectSpread({
    id: contentId(mod),
    entityId: contentId(mod)
  }, extraData);

  return props || {};
};
export var ContentfulModule = function ContentfulModule(props) {
  console.log('LEGACY modules ContentfulModule', props);
  return _jsx(EVEntry, _objectSpread({}, props.entity));
};
export var ContentfulModules = function ContentfulModules(_ref) {
  var _ref$modules = _ref.modules,
      modules = _ref$modules === void 0 ? [] : _ref$modules,
      className = _ref.className,
      extraData = _objectWithoutProperties(_ref, _excluded);

  if (!Array.isArray(modules)) return null;
  return modules.map(function (mod, idx) {
    return _createElement(EVEntry, _objectSpread(_objectSpread({}, mod), {}, {
      key: idx
    }));
  }, this);
};
//# sourceMappingURL=modules.js.map